"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
exports.updateAttributeContents = ({ step, el, log, }) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const attr = step.attributeName ? step.attributeName.trim() : '';
    if (!attr) {
        log('warn', {
            message: react_1.default.createElement(react_1.default.Fragment, null, "No attribute found to update."),
            plainTextMessage: 'No attribute found to update.',
        });
        return el;
    }
    const targettingInnerHtml = attr === '__innerHTML';
    const targettingOuterHtml = attr === '__outerHTML';
    const hasAttr = targettingInnerHtml
        ? !!((_a = el.innerHTML) === null || _a === void 0 ? void 0 : _a.trim())
        : el.hasAttribute(attr);
    if (hasAttr && step.doNothingIfAttributeExists) {
        log('warn', {
            message: (react_1.default.createElement(react_1.default.Fragment, null,
                "Attribute ",
                react_1.default.createElement("code", null,
                    "[",
                    attr,
                    "]"),
                " already exists and because 'do nothing if attribute exists' is set, Osmosys will do nothing.")),
            plainTextMessage: `Attribute [${attr}] already exists and because 'do nothing if attribute exists' is set, Osmosys will do nothing.`,
            previewHtml: targettingInnerHtml ? el.innerHTML : el.getAttribute(attr),
        });
        return el;
    }
    if (targettingInnerHtml) {
        el.innerHTML = step.attributeValue;
    }
    else if (targettingOuterHtml) {
        el.outerHTML = step.attributeValue;
    }
    else {
        el.setAttribute(attr, step.attributeValue);
    }
    log('success', {
        message: (react_1.default.createElement(react_1.default.Fragment, null,
            "Attribute ",
            react_1.default.createElement("code", null,
                "[",
                attr,
                "]"),
            " updated.")),
        plainTextMessage: `Attribute [${attr}] updated`,
    });
    return el;
});
//# sourceMappingURL=updateAttributeContents.js.map